import logger from 'loglevel';
import prefix from 'loglevel-plugin-prefix';

prefix.reg(logger);
prefix.apply(logger, {
    format(level, timestamp) {
        return `${timestamp} [${level}] -`;
    },
    levelFormatter(level) {
        const colors = {
            TRACE: '\x1b[34m', // Blue
            DEBUG: '\x1b[36m', // Cyan
            INFO: '\x1b[32m', // Green
            WARN: '\x1b[33m', // Yellow
            ERROR: '\x1b[31m' // Red
        };
        const resetColor = '\x1b[0m';
        return colors[level.toUpperCase()] ? colors[level.toUpperCase()] + level.toUpperCase() + resetColor : level;
    },
    timestampFormatter(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    template: '[%t] %l',
    levelFirst: false,
});

logger.setLevel(logger.levels.INFO);
logger.setLevel(logger.levels.TRACE);

export default logger;